export const COMMA = ",";
export const COLON = ":";
export const DASH = "-";
export const STARMARK = "*";
export const PLUSICON = "+";
